import React from 'react';

// reference: https://designportal.microsoft.com/media/?resetsearch=&field=metaproperty_Asset_Type&value=Illustrations&viewType=grid#
export const Dismiss = (props) => (
  <svg viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="446.444" y="380.751" width="92.9037" height="445.754" rx="46.4519" transform="rotate(135 446.444 380.751)" fill="url(#paint0_linear_3062_1896)" />
    <rect x="446.444" y="380.751" width="92.9037" height="445.754" rx="46.4519" transform="rotate(135 446.444 380.751)" fill="url(#paint1_radial_3062_1896)" />
    <rect x="446.444" y="380.751" width="92.9037" height="445.754" rx="46.4519" transform="rotate(135 446.444 380.751)" fill="url(#paint2_radial_3062_1896)" fillOpacity="0.89" />
    <rect x="446.444" y="380.751" width="92.9037" height="445.754" rx="46.4519" transform="rotate(135 446.444 380.751)" fill="url(#paint3_radial_3062_1896)" fillOpacity="0.75" />
    <rect x="446.444" y="380.751" width="92.9037" height="445.754" rx="46.4519" transform="rotate(135 446.444 380.751)" fill="url(#paint4_radial_3062_1896)" fillOpacity="0.75" />
    <rect x="381.912" y="66.3209" width="92.9037" height="445.754" rx="46.4519" transform="rotate(45.3498 381.912 66.3209)" fill="url(#paint5_linear_3062_1896)" />
    <rect x="381.912" y="66.3209" width="92.9037" height="445.754" rx="46.4519" transform="rotate(45.3498 381.912 66.3209)" fill="url(#paint6_radial_3062_1896)" fillOpacity="0.45" />
    <rect x="381.912" y="66.3209" width="92.9037" height="445.754" rx="46.4519" transform="rotate(45.3498 381.912 66.3209)" fill="url(#paint7_radial_3062_1896)" fillOpacity="0.5" />
    <rect x="381.912" y="66.3209" width="92.9037" height="445.754" rx="46.4519" transform="rotate(45.3498 381.912 66.3209)" fill="url(#paint8_radial_3062_1896)" fillOpacity="0.45" />
    <rect x="381.912" y="66.3209" width="92.9037" height="445.754" rx="46.4519" transform="rotate(45.3498 381.912 66.3209)" fill="url(#paint9_radial_3062_1896)" fillOpacity="0.45" />
    <circle cx="378.719" cy="378.468" r="33.305" fill="url(#paint10_radial_3062_1896)" />
    <circle cx="378.719" cy="378.468" r="33.305" fill="url(#paint11_radial_3062_1896)" fillOpacity="0.8" />
    <circle cx="195.5" cy="294.5" r="1.5" fill="#FEE39E" />
    <circle cx="404.5" cy="160.5" r="1.5" fill="#FEE39E" />
    <circle cx="386.5" cy="160.5" r="1.5" fill="#FEE39E" />
    <circle cx="132" cy="385.5" r="1.5" fill="#FEE39E" />
    <circle cx="266.5" cy="205" r="1.5" fill="#FEE39E" />
    <circle cx="332.5" cy="222" r="1.5" fill="#FEE39E" />
    <circle cx="137.5" cy="160.5" r="1.5" fill="#FEE39E" />
    <circle cx="188" cy="171.5" r="1.5" fill="#FEE39E" />
    <circle cx="318.5" cy="349.5" r="1.5" fill="#FEE39E" />
    <circle cx="371.5" cy="333" r="1.5" fill="#FEE39E" />
    <circle cx="275" cy="315" r="1.5" fill="#FEE39E" />
    <circle cx="353.5" cy="313.5" r="1.5" fill="#FEE39E" />
    <circle cx="195.5" cy="303.5" r="1.5" fill="#FEE39E" />
    <circle cx="231" cy="191" r="1.5" fill="#FEE39E" />
    <circle cx="145" cy="152" r="1.5" fill="#FEE39E" />
    <circle cx="377.219" cy="106" r="1.5" fill="#FEE39E" />
    <circle cx="389" cy="150" r="1" fill="#FEE39E" />
    <circle cx="346.414" cy="324" r="1" fill="#FEE39E" />
    <circle cx="335" cy="390.5" r="1" fill="#FEE39E" />
    <circle cx="142.5" cy="148" r="1" fill="#FEE39E" />
    <circle cx="203" cy="210" r="1" fill="#FEE39E" />
    <circle cx="180" cy="346.163" r="1" fill="#FEE39E" />
    <defs>
      <linearGradient id="paint0_linear_3062_1896" x1="541.687" y1="598.68" x2="446.935" y2="597.266" gradientUnits="userSpaceOnUse">
        <stop offset="0.214569" stopColor="#DB9FF8" />
        <stop offset="0.666507" stopColor="#C053F5" />
      </linearGradient>
      <radialGradient id="paint1_radial_3062_1896" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(553.56 384.375) rotate(95.4172) scale(226.048 130.801)">
        <stop offset="0.810759" stopColor="#EB4246" />
        <stop offset="1" stopColor="#BD122A" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint2_radial_3062_1896" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(511.281 419.075) rotate(-34.7288) scale(47.7094 35.0711)">
        <stop offset="0.661458" stopColor="#780003" />
        <stop offset="1" stopColor="#EC4347" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint3_radial_3062_1896" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(435.543 574.675) rotate(87.9261) scale(301.672 60.2674)">
        <stop offset="0.428584" stopColor="#7103A8" />
        <stop offset="0.84375" stopColor="#9B30CF" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint4_radial_3062_1896" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(429.964 553.425) rotate(-19.7279) scale(257.661 38.8797)">
        <stop offset="0.479341" stopColor="#85080B" />
        <stop offset="1" stopColor="#85080B" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="paint5_linear_3062_1896" x1="428.364" y1="66.3209" x2="428.364" y2="512.075" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF9946" />
        <stop offset="0.44569" stopColor="#FF7000" />
        <stop offset="0.729658" stopColor="#DF2000" />
        <stop offset="1" stopColor="#C52200" />
      </linearGradient>
      <radialGradient id="paint6_radial_3062_1896" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(484.878 263.785) rotate(92.8478) scale(359.36 45.8075)">
        <stop offset="0.46875" stopColor="#810000" />
        <stop offset="1" stopColor="#810000" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint7_radial_3062_1896" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(372.785 267.274) rotate(90.8254) scale(302.71 45.2859)">
        <stop offset="0.515625" stopColor="#FECEBA" />
        <stop offset="0.942708" stopColor="#FECEBA" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint8_radial_3062_1896" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(408.82 154.534) rotate(90.3405) scale(74.8661 15.6035)">
        <stop offset="0.260417" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint9_radial_3062_1896" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(420.919 206.146) rotate(88.6059) scale(306.02 138.658)">
        <stop offset="0.799836" stopColor="#FF9886" stopOpacity="0" />
        <stop offset="0.91325" stopColor="#FF9886" />
        <stop offset="0.949456" stopColor="#FF9886" />
        <stop offset="1" stopColor="#FF9886" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint10_radial_3062_1896" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(385.018 363.205) rotate(108.435) scale(61.2279)">
        <stop stopColor="white" />
        <stop offset="0.25" stopColor="#FFEFDA" />
        <stop offset="0.645065" stopColor="#C9B08F" />
        <stop offset="0.831818" stopColor="#E2D5C3" />
      </radialGradient>
      <radialGradient id="paint11_radial_3062_1896" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(378.719 378.468) rotate(97.8153) scale(59.12)">
        <stop offset="0.446038" stopColor="white" stopOpacity="0" />
        <stop offset="0.841379" stopColor="white" />
      </radialGradient>
    </defs>
  </svg>
);

Dismiss.displayName = 'Dismiss';
